import { computed, inject, Injectable, Signal, Type } from '@angular/core';
import { AdditionalTableConfigProvider, ViewAction } from '@antony/ng-ui';
import { FullscreenToggleService } from './fullscreen-toggle.service';
import { DisableFullscreenViewAction, EnableFullscreenViewAction } from './view-actions';

@Injectable()
export class TableConfigProvider extends AdditionalTableConfigProvider {
  private readonly fullScreenService = inject(FullscreenToggleService);
  private readonly classList = computed(() => (this.fullScreenService.isFullScreen() ? 'is-fullscreen' : []));
  private readonly actions = computed(() => (this.fullScreenService.isFullScreen() ? [DisableFullscreenViewAction] : [EnableFullscreenViewAction]));

  get classes(): Signal<string | readonly string[] | Record<string, boolean>> {
    return this.classList;
  }

  get footerActions(): Signal<readonly Type<ViewAction<undefined>>[]> {
    return this.actions;
  }
}
